import { takeEvery, call, put, select } from 'redux-saga/effects'

import { isEmpty } from 'app/utils/array'
import { getSounds } from 'app/services/api/data.service'
import { soundKeys } from 'app/constants/sounds.constants'

import {
  SOUNDS_ACTIONS,
  SONIDOS_ACTIONS,
  soundsActionCreators,
  sonidosActionCreators,
} from 'app/store/actions/media/sounds.actions'
import { ReduxSagaAction } from 'app/types/store.types'

const actions = {
  SOUNDS: soundsActionCreators,
  SONIDOS: sonidosActionCreators,
}

function* getSoundsSaga({
  payload: soundCategory,
}: ReduxSagaAction<keyof typeof soundKeys>): Generator<unknown, void, any> {
  let action
  try {
    const soundKey = soundKeys[soundCategory]
    let data = yield select((state) => state.sounds[soundKey].data)
    action = actions[soundCategory] || actions.SOUNDS

    if (isEmpty(data.items) || isEmpty(data.groups)) {
      data = yield call(getSounds, soundCategory)
    }

    yield put(action.success({ data }))
  } catch (error) {
    if (action) {
      yield put(action.failure({ error }))
    }
  }
}

export default function* watchSoundsActions() {
  yield takeEvery(
    [SOUNDS_ACTIONS.REQUEST, SONIDOS_ACTIONS.REQUEST],
    getSoundsSaga
  )
}
